import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class BrandingService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiBaseUrl.replace(/\/$/, '');

  /** Bundled static logo; used as fallback when no tenant branding is available. */
  static readonly STATIC = '/assets/images/logo.svg';

  /** Current app logo: tenant company logo when known, else the bundled static asset. */
  readonly logoUrl = signal<string>(BrandingService.STATIC);

  /** Authenticated surfaces call this with the profile's company_logo (presigned URL or null). */
  setFromProfile(companyLogo: string | null): void {
    this.logoUrl.set(companyLogo && companyLogo.length > 0 ? companyLogo : BrandingService.STATIC);
  }

  /** Unauthenticated surfaces (login pages) resolve the logo by subdomain from the host. */
  loadPublic(): void {
    const sub = window.location.hostname.split('.')[0];
    if (!sub) return;
    this.http
      .get<{ data?: { logo?: string | null } }>(`${this.base}/branding/logo`, { params: { subdomain: sub } })
      .subscribe({
        next: (res) => {
          const logo = res?.data?.logo;
          if (logo) this.logoUrl.set(logo);
        },
        error: () => { /* keep static fallback */ },
      });
  }
}
